<template>
  <div class="termsPopup__content">
    <div class="modal_titleForm termsPopup__title">{{ $t('qic_payment_terms_title')}}</div>
    <div class="termsPopup__text">{{ $t('qic_payment_terms_conditions_dibsy')}}</div>
  </div>
</template>

<script>
export default {
  name: 'TermsPopupDibsy'
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transition: opacity .05s;
}
</style>
